const labels = {
  'errors.notfoundError.title': '404 Error Page not found',
  'errors.internalError.title': '500 Error Internal server error',
  'errors.internalErrorAdvisor.title': 'Internal server error',
  'errors.forbiddenError.title': '403 Error Access denied',
  'errors.forbiddenErrorUnlicensed.title': 'Access denied',
  'errors.forbiddenErrorUnlicensed.message':
    'Sorry, we are not able to complete your request. You can try again at a later time or contact Advisor Support by calling 1-877-654-2757 or emailing am_brokersupport@manulife.ca.',
  'errors.internalErrorAdvisor.message': 'Sorry, we are not able to complete your request. Please try again later.',
  'errors.forbiddenErrorWeblink.title': '404 Error Page not found',
  'errors.forbiddenErrorWeblink.message':
    'It may no longer exist, but first, please make sure the website address you entered is correct.',
  'errors.forbiddenErrorWeblink.retry1': 'Copied and pasted a link, check that you selected the entire link.',
  'errors.forbiddenErrorWeblink.retry2': 'Typed a link into the address bar, try retyping it.',
  'errors.message.retry1':
    'It may no longer exist, but first, please make sure the website address you entered is correct:',
  'errors.message.retry2': 'Copied and pasted a link, check that you selected the entire link.',
  'errors.message.retry3': 'Typed a link into the address bar, try retyping it.',
  'errors.message.retry4': "If it still doesn't work, please contact the HelpDesk."
};

export default labels;
